import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { BlogService } from '../blogs/blog.service';
import { IBlog, BlogDetails, IOffer, OfferDetails, IArticle, ArticleDetails } from '../blogs/blog';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;
@Component({
  templateUrl: "./rssnewsfeeddetails.component.html"
})
export class RssNewsFeedDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle: string = 'Driving News Detail';
  p: number = 1;
  articlesList: IArticle[];
  iarticle: IArticle[];
  article: ArticleDetails = new ArticleDetails();
  slug: string;
  private sub: any;
  constructor(private authService: AuthService,
    public blogService: BlogService,
    private route: ActivatedRoute,
    private appCommonService: AppCommonService,
    private _location: Location
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this.loadArticlesList();
      window.scrollTo(0, 0);
    });
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  loadArticlesList() {
    this.blogService.getDrawingArticlesList()
      .subscribe(
      (articles: IArticle[]) => {
        this.iarticle = articles.filter(b => b.slug == this.slug);
        articles = articles.filter(b => b.slug != this.slug);
        this.articlesList = articles;        
      },
      (error: any) => {
        this.blogService.showError("Driving news retrieval problem", <any>error)
      }
      );
  }

  onBack() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/rssnewsfeeddetails.component.ts